package io.horion.cv.api.usecase

import io.horion.cv.api.datasource.job.ApplyJob
import io.horion.cv.api.datasource.job.ApplyJobStatus
import io.horion.cv.api.datasource.job.Job
import io.horion.cv.api.datasource.response.Response
import io.horion.cv.api.repository.job.JobRepository
import io.horion.cv.api.utils.TokenRepository.apiWithTokenRetry

class JobUseCase(
    private val apiJob : JobRepository
) {
    suspend fun createCv(job: Job) : Response? {
        return apiWithTokenRetry { token ->
            apiJob.createJob(token, job)
        }
    }

    suspend fun updateJob(uuid : String, job: Job): Response? {
        return apiWithTokenRetry { token ->
            apiJob.updateJob(token, uuid, job)
        }
    }

    suspend fun deleteJob(uuid: String): Response? {
        return apiWithTokenRetry { token ->
            apiJob.deleteJob(token, uuid)
        }
    }

    suspend fun applyJob(applyJob: ApplyJob): Response? {
        return apiWithTokenRetry { token ->
            apiJob.applyJob(token, applyJob)
        }
    }

    suspend fun updateApplyStatus(uuid: String, status: ApplyJobStatus, comments : String?): Response? {
        return apiWithTokenRetry { token ->
            apiJob.updateApplyStatus(token, uuid, status, comments)
        }
    }

    suspend fun getAppliesJob(uuid: String): List<ApplyJob>? {
        return apiWithTokenRetry { token->
            apiJob.getAppliesJob(token,uuid)
        }
    }

    suspend fun findJobByUuid(uuid: String): Job? {
        return apiJob.findJobByUuid(uuid)
    }

    suspend fun findJobsByEnterpriseUuid(enterpriseUuid: String): List<Job>? {
        return apiWithTokenRetry { token->
            apiJob.findJobsByEnterpriseUuid(token,enterpriseUuid)
        }
    }

    suspend fun findAllJobs(): List<Job> {
        return apiJob.findAllJobs()
    }

}